<template>
  <b-container fluid>
    <b-row class="my-1">
      <b-col md="4" sm="8" xs="8" class="ml-auto">
        <b-container fluid class="px-0">
          <b-row no-gutters v-if="sectionTable" class="my-0 px-6">
            <b-col cols="8" class="ml-auto">
              <b-form-input
                :id="'input-table-keyword-' + sectionTable.key"
                size="sm"
                v-model="sectionTable.keyword"
                placeholder="Keyword Search"
                debounce="250"
              >
              </b-form-input>
            </b-col>
            <b-col cols="4" class="ml-auto" v-if="sectionTable.IsMultipliable">
              <b-form-input
                number
                :id="'input-table-multiplier-' + sectionTable.key"
                size="sm"
                v-model="sectionTable.multiplier"
                placeholder="Multiplier"
                debounce="250"
              >
              </b-form-input>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col
        :md="sideBarModel.visible && containsActivePCN ? 6 : 12"
        sm="12"
        v-if="!isTableHidden"
        :class="{
          'd-none d-sm-block': sideBarModel.visible && containsActivePCN,
        }"
      >
        <b-table
          ref="bSectiontable"
          class="table-table w-auto"
          v-if="
            sectionTable &&
            !sectionTable.loading &&
            sectionTable.fields.length > 0
          "
          :class="{ 'min-table': isFilterMode }"
          striped
          hover
          small
          bordered
          responsive
          selectable
          select-mode="single"
          sticky-header="500px"
          :items="sectionTable.filteredModels"
          :fields="fields"
          :no-local-sorting="true"
          @sort-changed="onSort"
          :per-page="0"
          @row-clicked="onRowClicked"
          primary-key="PcnCatalogNumber"
        >
          <template v-slot:head()="fieldData">
            <b-container fluid>
              <b-row>
                <b-col
                  :cols="
                    !screen.lt.md ||
                    (isFilterMode &&
                      (fieldData.field.column.SortBy ||
                        fieldData.field.column.FilterBy ||
                        fieldData.field.column.KeywordSearchBy))
                      ? 9
                      : 12
                  "
                  v-if="screen.lt.md"
                  class="pr-0"
                >
                  <template
                    v-if="
                      fieldData.field.key != 'FingoodTpiMfgMod' &&
                      fieldData.field.key != 'DivisionModelNumbers' &&
                      fieldData.field.key != 'addItem'
                    "
                  >
                    <b-form-select
                      style="text-align: center"
                      :value="mobileColumnKey"
                      :options="columns"
                      value-field="key"
                      text-field="DisplayName"
                      size="sm"
                      @input="setMobileColumnKey({ value: $event })"
                    >
                      <template v-slot:first>
                        <b-form-select-option value=""
                          >Choose field</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </template>
                </b-col>
                <b-col
                  v-if="
                    !screen.lt.md ||
                    (isFilterMode &&
                      (fieldData.field.column.SortBy ||
                        fieldData.field.column.FilterBy ||
                        fieldData.field.column.KeywordSearchBy))
                  "
                  :cols="
                    screen.lt.md &&
                    fieldData.field.key != 'FingoodTpiMfgMod' &&
                    fieldData.field.key != 'DivisionModelNumbers'
                      ? 3
                      : 12
                  "
                  :class="
                    screen.lt.md &&
                    fieldData.field.key != 'FingoodTpiMfgMod' &&
                    fieldData.field.key != 'DivisionModelNumbers'
                      ? 'pl-0'
                      : ''
                  "
                >
                  <b-dropdown
                    no-flip
                    size="sm"
                    no-caret
                    :variant="isFilterMode ? 'outline-secondary' : 'none'"
                    split-variant="outline-primary"
                    v-if="fieldData.field.column.SectionTableLayoutColumnId > 0"
                    :title="
                      fieldData.field.column.DisplayDescription &&
                      fieldData.field.column.DisplayDescription.length > 0
                        ? fieldData.field.column.DisplayDescription
                        : fieldData.field.column.DisplayName
                    "
                    boundary="window"
                    block
                    class="tpi-disabled"
                    :disabled="!isFilterMode"
                    menu-class="w-100 tpi-dropdown"
                  >
                    <template v-slot:button-content>
                      <b-button
                        title="Click Column to Sort and Filter"
                        variant="outline-secondary"
                        size="sm"
                        flush
                        style="border: 0; padding: 0"
                        v-if="
                          isFilterMode &&
                          (fieldData.field.column.SortBy ||
                            fieldData.field.column.FilterBy ||
                            fieldData.field.column.KeywordSearchBy)
                        "
                      >
                        <b-badge
                          pill
                          variant="secondary"
                          title="Filter Count"
                          style="position: absolute; top: 4px; right: 4px"
                          v-if="isFiltered(fieldData.field.column)"
                        >
                          {{ selectedFilterCount(fieldData.field.column) }}
                        </b-badge>
                        <b-badge
                          pill
                          variant="secondary"
                          title="Sort"
                          style="
                            position: absolute;
                            top: 4px;
                            left: 4px;
                            padding: 2px;
                          "
                          v-if="fieldData.field.column.sort != 0"
                        >
                          <b-icon
                            icon="arrow-up"
                            v-if="fieldData.field.column.sort == -1"
                            aria-hidden="true"
                          ></b-icon>
                          <b-icon
                            icon="arrow-down"
                            v-if="fieldData.field.column.sort == 1"
                            aria-hidden="true"
                          ></b-icon>
                        </b-badge>
                      </b-button>
                      <template
                        v-if="
                          !screen.lt.md ||
                          fieldData.field.key == 'FingoodTpiMfgMod' ||
                          fieldData.field.key == 'DivisionModelNumbers'
                        "
                      >
                        {{ fieldData.label }}
                      </template>
                      <b-icon
                        :icon="
                          isFiltered(fieldData.field) ? 'funnel-fill' : 'funnel'
                        "
                        aria-hidden="true"
                        v-if="
                          isFilterMode &&
                          (fieldData.field.column.SortBy ||
                            fieldData.field.column.FilterBy ||
                            fieldData.field.column.KeywordSearchBy)
                        "
                      >
                      </b-icon>
                    </template>

                    <template v-if="isFilterMode">
                      <template
                        v-if="
                          fieldData.field.column.SortBy ||
                          fieldData.field.column.FilterBy ||
                          fieldData.field.column.KeywordSearchBy
                        "
                      >
                        <b-dropdown-header class="display-description">{{
                          fieldData.field.column.DisplayDescription
                        }}</b-dropdown-header>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-group v-if="fieldData.field.column.SortBy">
                          <b-button-toolbar class="col-md-4 text-center">
                            <b-button-group size="sm">
                              <b-button
                                title="Z to A"
                                variant="outline-dark"
                                @click="
                                  onSort({
                                    tableLayoutColumn: fieldData.field.column,
                                    sort: -1,
                                  })
                                "
                              >
                                <b-icon
                                  icon="arrow-up"
                                  :variant="
                                    fieldData.field.column.sort == -1
                                      ? 'success'
                                      : ''
                                  "
                                  aria-hidden="true"
                                ></b-icon>
                              </b-button>
                              <b-button
                                title="A to Z"
                                variant="outline-dark"
                                @click="
                                  onSort({
                                    tableLayoutColumn: fieldData.field.column,
                                    sort: 1,
                                  })
                                "
                              >
                                <b-icon
                                  icon="arrow-down"
                                  :variant="
                                    fieldData.field.column.sort == 1
                                      ? 'success'
                                      : ''
                                  "
                                  aria-hidden="true"
                                ></b-icon>
                              </b-button>
                            </b-button-group>
                          </b-button-toolbar>
                        </b-dropdown-group>
                        <template v-if="fieldData.field.column.KeywordSearchBy">
                          <b-dropdown-divider></b-dropdown-divider>
                          <b-dropdown-form>
                            <b-form-input
                              :id="
                                'input-search-' +
                                sectionTable.key +
                                '-' +
                                fieldData.field.column.key
                              "
                              v-model="fieldData.field.column.keyword"
                              placeholder="Search"
                              @input="
                                onKeywordInput({
                                  tableLayoutColumn: fieldData.field.column,
                                })
                              "
                            ></b-form-input>
                          </b-dropdown-form>
                        </template>
                        <template v-if="fieldData.field.column.FilterBy">
                          <b-dropdown-divider></b-dropdown-divider>
                          <b-dropdown-form class="filter-form">
                            <template
                              v-for="facet in fieldData.field.column.facets"
                            >
                              <b-form-checkbox
                                :key="'facet-' + facet.key"
                                v-model="facet.selected"
                                @input="
                                  onFacetClick({
                                    tableLayoutColumn: fieldData.field.column,
                                  })
                                "
                                v-if="facet.count > 0"
                              >
                                {{
                                  facet.displayName != ''
                                    ? facet.displayName
                                    : '[Blank]'
                                }}
                                <b-badge pill variant="secondary"
                                  >{{ facet.count }}
                                </b-badge>
                              </b-form-checkbox>
                            </template>
                          </b-dropdown-form>
                        </template>
                        <template
                          v-if="
                            fieldData.field.column.FilterBy ||
                            fieldData.field.column.KeywordSearchBy
                          "
                        >
                          <b-dropdown-divider></b-dropdown-divider>
                          <b-dropdown-item-button
                            @click="clearFilters(fieldData.field.column)"
                          >
                            <b-icon
                              icon="x"
                              variant="danger"
                              aria-hidden="true"
                            ></b-icon>
                            Clear
                          </b-dropdown-item-button>
                        </template>
                      </template>
                    </template>
                  </b-dropdown>
                </b-col>
                <b-col
                  v-else-if="
                    fieldData.field.key == 'FingoodTpiMfgMod' ||
                    fieldData.field.key == 'DivisionModelNumbers'
                  "
                >
                  {{ fieldData.label }}
                </b-col>
              </b-row>
            </b-container>
          </template>
          <template v-slot:cell(addItem)="row">
            <div v-if="isUsedByRequestSite">
              <b-button
                v-if="selectedItem !== row.item.PcnCatalogNumber"
                size="sm"
                variant="info background-color-primary"
                @click.stop="setSearchedPcnCatalogNumber(row.item.PcnCatalogNumber)"
                title="Add model to the searching."
              >
                <b-icon-check-square aria-hidden="true"></b-icon-check-square>
              </b-button>
            </div>
            <div v-if="isUsedByOrdersSite">
              <b-button
                v-if="selectedItem !== row.item.PcnCatalogNumber"
                size="sm"
                variant="info background-color-primary"
                @click.stop="handleSelectItem(row.item.PcnCatalogNumber)"
                data-cy="selected-item"
              >
                <b-icon-plus-circle aria-hidden="true"></b-icon-plus-circle>
              </b-button>
              <div
                v-if="
                  showQuantityInput &&
                  selectedItem === row.item.PcnCatalogNumber
                "
              >
                <b-form-input
                  class="input-quantity"
                  v-model="quantity"
                  type="number"
                  min="1"
                  size="sm"
                ></b-form-input>
                <b-input-group>
                  <b-button
                    size="sm"
                    variant="outline-success"
                    @click.stop="handleAddItemToOrder(row.item, quantity)"
                    data-cy="add-selected-item"
                    ><b-icon icon="check"></b-icon
                  ></b-button>
                  <b-button
                    size="sm"
                    variant="link"
                    @click.stop="selectedItem = ''"
                    ><b-icon icon="x" variant="danger"></b-icon
                  ></b-button>
                </b-input-group>
              </div>
            </div>
          </template>

          <template v-slot:cell(viewDetails)="row">
            <b-button
              variant="outline-primary"
              aria-controls="details-sidebar"
              :aria-expanded="
                sideBarModel && sideBarModel.visible ? 'true' : 'false'
              "
              @click="onRowClicked(row.item)"
              size="sm"
              class="px-1 py-0"
              :pressed="
                sideBarModel.model.PcnCatalogNumber ===
                row.item.PcnCatalogNumber && containsActivePCN
              "
            >
              <b-icon-info-circle aria-hidden="true"></b-icon-info-circle>
            </b-button>
          </template>

          <template v-slot:cell(options)="row">
            <b-button
              variant="link"
              aria-controls="details-sidebar"
              :aria-expanded="
                sideBarModel && sideBarModel.visible ? 'true' : 'false'
              "
              @click="onRowClicked(row.item)"
              size="sm"
              class="px-1 py-0"
              :pressed="
                sideBarModel.model.PcnCatalogNumber ===
                row.item.PcnCatalogNumber
              "
            >
              <b-icon icon="cart-plus"></b-icon>
            </b-button>
          </template>

          <template v-slot:cell()="data">
            <template
              v-if="data.field.column.ParentFormatType === formatType.List"
            >
              <component
                :is="data.field.column.ParentFormatValue || 'ul'"
                v-for="value in data.value"
                :key="value.key"
                class="text-center"
              >
                <component :is="data.field.column.FormatValue">
                  <template
                    v-if="data.field.column.PropertyType == propertyType.String"
                    >{{ value }}</template
                  >
                  <template v-else>{{
                    getObjectValue(value, data.field.column)
                  }}</template>
                </component>
              </component>
            </template>
            <template
              v-else-if="data.field.column.PropertyName == propertyType.Image"
            >
              <b-img
                v-if="(sectionTable.TableLayout.DisplayName ?? '').toLocaleLowerCase().includes('replacement') || data.value"
                class="text-center"
                fluid
                :src="data?.value?.ImagePath + '?width=50&height=50'"
                @error="event => _loadErrorImage(event, '50','50')"
              />
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template v-slot:cell(showInventory)="row">
            <modal-inventory :item="row.item"></modal-inventory>
          </template>
          <!-- <template v-slot:cell(addItemToCart)="row">
          </template> -->
        </b-table>
        <template v-if="sectionTable.loading">
          <loading-text></loading-text>
        </template>
      </b-col>

      <b-col
        :md="sectionTable.Cols == 12 ? 6 : 12"
        sm="12"
        class="detailsTest"
        v-if="sideBarModel.visible && containsActivePCN"
      >
        <portal :disabled="!showPrintView" to="print-bottom">
          <b-card no-body class="detail-card">
            <b-card-header class="py-1" header-tag="h2">
              Model Details
              <b-button-toolbar class="float-md-right">
                <b-button-group size="sm" class="mx-1">
                  <b-button
                    title="Close"
                    variant="light"
                    @click="closeDetails()"
                  >
                    <b-icon icon="x" aria-hidden="true"></b-icon>
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-card-header>
            <b-card-body class="product-details-scroll">
              <model-details-card
                v-if="!sideBarModel.model.isNone"
                :model="sideBarModel.model"
                :tableLayout="sideBarModel.tableLayout"
                :sectionTable="sectionTable"
              >
              </model-details-card>
            </b-card-body>
          </b-card>
        </portal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import _ from 'lodash'

import ModelDetailsCard from '@/components/model-details-card.vue'
import LoadingText from '@/components/utility/loading-text.vue'
import {
  Model,
  Product,
  SectionTable,
  SideBarItem,
  TableLayoutColumn,
} from '@/store/product/types'
import { BTable } from 'bootstrap-vue'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import modalInventory from '@/components/inventory/modal-inventory.vue'

import MxSite from '@/mixins/site'
const nsProduct = namespace('product')
const nsMultiplier = namespace('multiplier')

@Component({
  components: {
    'loading-text': LoadingText,
    'model-details-card': ModelDetailsCard,
    'modal-inventory': modalInventory,
  },
})
export default class extends Mixins(MxSite) {
  @Prop()
  public isUsedByOrdersSite!: false

  @Prop()
  public isUsedByRequestSite!: false

  @Prop()
  public product!: Product

  @Prop()
  public sectionTable!: SectionTable

  @Prop()
  public saveCartItem: any

  @Prop()
  public updateTerm: any

  @Prop()
  public handleAddItemToOrder: any

  public mobileColumnKey = 'PcnCatalogNumber'

  @nsProduct.Getter('sideBarModel')
  public sideBarModel!: SideBarItem

  @nsProduct.Mutation('setCurrentPage')
  private setCurrentPage: any

  @nsProduct.Mutation('toggleFilterVisible')
  private toggleFilterVisible: any

  @nsProduct.Mutation('updateSort')
  private updateSort: any

  @nsProduct.Action('clearColumnFilters')
  private clearColumnFilters: any

  @nsProduct.Mutation('updateActiveModel')
  private updateActiveModel: any

  @nsProduct.Mutation('setActiveModel')
  private setActiveModel: any

  @nsProduct.Mutation('clearActiveModel')
  private clearActiveModel: any

  @nsProduct.Action('applyFilters')
  private applyFilters!: any

  @nsProduct.Action('applyKeyword')
  private applyKeyword!: any

  @nsProduct.Action('applySorts')
  private applySorts!: any

  @nsProduct.Mutation('setPrintView')
  private setPrintView: any

  @nsProduct.State('showPrintView')
  public showPrintView!: boolean

  @nsMultiplier.Getter('getMultiplierPrice')
  private getMultiplierPrice: any

  private created() {
    this.setPrintView({ value: false })
  }

  public quantity = 1
  public showQuantityInput = false
  public selectedItem = ''

  get containsActivePCN(): boolean {
    const { sectionTable, sideBarModel } = this
    return (
      sideBarModel.model &&
      sectionTable.Models.some(
        (model) =>
          model.PcnCatalogNumber === sideBarModel.model.PcnCatalogNumber,
      ) &&
      sideBarModel.sectionTable.DisplayName === sectionTable.DisplayName
    )
  }

  // TODO: product?
  @Watch('product')
  private watchProduct() {
    this.setPrintView({ value: false })
  }

  public clickPrint() {
    this.setPrintView({ value: true })
    setTimeout(() => {
      window.print()
    }, 500)
  }

  public closeDetails() {
    const { query } = this.$route

    const newQuery = _.assign({}, query)

    this.clearActiveModel()
    delete newQuery.catalogNumber

    this.$router.replace({ query: newQuery })
  }

  get isTableHidden(): boolean {
    const { sideBarModel, containsActivePCN, sectionTable } = this
    return sideBarModel.visible && containsActivePCN && sectionTable.Cols < 12
  }

  get isFilterMode() {
    return (
      this.sectionTable &&
      this.sectionTable.Models &&
      this.sectionTable.Models &&
      !this.sectionTable.HideTableFilters
    )
  }

  get fields() {
    const { sectionTable, screen, mobileColumnKey } = this
    const customOrder = ['TotalList', 'showInventory', 'FingoodTpiMfgMod', 'Image', 'PcnCatalogNumber', 'addItem', 'viewDetails'] // order reversed due to stack
    sectionTable.fields.sort((a, b) => {
      const indexA = customOrder.indexOf(a.key)
      const indexB = customOrder.indexOf(b.key)

      return indexB - indexA
    })
    if (!screen.lt.md) {
      return [
        {
          label: '',
          class: '',
          column: '',
          key: 'addItem',
          formatter: () => undefined,
        },
        ...sectionTable.fields,
      ]
    }
    const secondField =
      mobileColumnKey === ''
        ? {
            label: '',
            class: '',
            column: '',
            key: 'dropdown',
            formatter: () => undefined,
          }
        : sectionTable.fields.find((f) => f.key === mobileColumnKey)
    // TODO: FingoodTpiMfgMod will change with Model Number trickery for multisite

    return [
      sectionTable.fields.find(
        (f) => f.key === 'FingoodTpiMfgMod' || f.key === 'DivisionModelNumbers',
      ),
      secondField,
      {
        label: '',
        class: '',
        column: '',
        key: 'addItem',
        formatter: () => undefined,
      },
    ]
  }

  get columns() {
    return this.sectionTable.TableLayout.Columns.filter(
      (c) =>
        c.key !== 'FingoodTpiMfgMod' &&
        c.key !== 'DivisionModelNumbers' &&
        !c.isCustom,
    )
  }

  public onSort({
    tableLayoutColumn,
    sort,
  }: {
    tableLayoutColumn: TableLayoutColumn
    sort: number
  }) {
    const { sectionTable } = this
    this.updateSort({ sectionTable, tableLayoutColumn, sort })
    this.applySorts({ sectionTable, tableLayoutColumn, sort })
  }

  public onKeywordInput({
    tableLayoutColumn,
  }: {
    tableLayoutColumn: TableLayoutColumn
  }) {
    const { sectionTable } = this
    if (sectionTable) {
      this.applyFilters({ sectionTable, tableLayoutColumn })
    }
  }

  public onFacetClick({
    tableLayoutColumn,
  }: {
    tableLayoutColumn: TableLayoutColumn
  }) {
    const { sectionTable } = this
    if (sectionTable) {
      // const tableLayoutColumn = sectionTable.TableLayout.Columns.find(c => c.key === fieldKey)
      // this.updateFacet({ tableLayoutColumn, facet })
      this.applyFilters({ sectionTable, tableLayoutColumn })
    }
  }

  public selectedFilterCount(tableLayoutColumn: TableLayoutColumn): number {
    return (
      tableLayoutColumn.facets.filter(
        (facet) => facet.count > 0 && facet.selected,
      ).length + (tableLayoutColumn.keyword ? 1 : 0)
    )
  }

  public isFiltered(tableLayoutColumn: TableLayoutColumn): boolean {
    if (!tableLayoutColumn.facets) {
      return false
    }
    return (
      tableLayoutColumn.facets.filter(
        (facet) => facet.count > 0 && facet.selected,
      ).length > 0 || !!tableLayoutColumn.keyword
    )
  }

  public clearFilters(tableLayoutColumn: TableLayoutColumn) {
    const { sectionTable } = this
    this.clearColumnFilters({ sectionTable, tableLayoutColumn })
  }

  public onRowClicked(item: Model) {
    if ((this.sectionTable as SectionTable).DetailsPanel) {
      this.setSelected(item)
    }
  }

  public setMobileColumnKey({ value }: { value: string }) {
    this.mobileColumnKey = value
  }

  public setSelected(model: Model) {
    const table = this.sectionTable as SectionTable
    const tableLayout = table.TableLayout
    if (this.sideBarModel.model.PcnCatalogNumber === model.PcnCatalogNumber && this.sideBarModel.sectionTable.DisplayName === table.DisplayName) {
      this.clearActiveModel()
    } else {
      this.setActiveModel({ model, tableLayout, sectionTable: table })
    }
  }

  @Watch('sectionTable.multiplier')
  private multiplierChanged() {
    const { sectionTable } = this
    if (sectionTable) {
      const tableLayoutColumn = sectionTable.TableLayout.Columns.find(
        (c) => c.PropertyName === 'TotalList',
      )
      // const tableLayoutColumn = sectionTable.TableLayout.Columns.find(c => c.key === fieldKey)
      // this.updateKeyword({ tableLayoutColumn, keyword })
      if (tableLayoutColumn) {
        this.applyFilters({ sectionTable, tableLayoutColumn }) // this way it will recalculate the values in the filters!
      }
    }
  }

  // TODO: Debounce?
  @Watch('sectionTable.keyword')
  private keywordChanged() {
    const { sectionTable } = this
    if (sectionTable) {
      this.applyKeyword({ sectionTable }) // this way it will recalculate the values in the filters!
    }
  }

  @Watch('sideBarModel.index')
  private onModelChanged(indexNew: number, indexOld: number) {
    if (indexOld !== indexNew) {
      const bTable = this.$refs.bSectiontable as unknown as BTable
      if (bTable) {
        bTable.selectRow(indexNew)
      }
    }
  }

  public handleSelectItem(pcnCatalogNumber: string) {
    this.showQuantityInput = true
    this.quantity = 1
    this.selectedItem = pcnCatalogNumber
  }

  public setSearchedPcnCatalogNumber(pcnCatalogNumber: string) {
    this.updateTerm(pcnCatalogNumber)
    this.toastSuccess('Model ' + pcnCatalogNumber + ' selected')
  }
}
</script>
<style>
.detailsTest .detail-card .product-details-scroll .detail-container {
  max-height: 500px;
  overflow: auto;
}

.section-table-container .table {
  width: auto !important;
}
.tpi-dropdown {
  min-width: 250px !important;
}

.tpi-disabled button {
  opacity: 1 !important;
}

.tpi-details-cell {
  width: 38px;
}

/*
.section-table-container .table-responsive {
  width: auto !important;
} */
</style>
<style scoped>
ul {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
/* .table-card {
  min-height: 506px;
} */
/* .table-table {
  min-height: 506px;
} */

.min-table {
  min-height: 500px;
}
.display-description .dropdown-header {
  padding: 0.5rem 0.5rem;
  max-width: 200px;
  white-space: normal;
}

.filter-form {
  max-height: 200px;
  overflow: auto;
  /* min-width: 200px; */
}
/* If we disable details for certain Layouts, this will need fixing */
.scroll-dropdown .dropdown-menu {
  max-height: 400px;
  max-width: 500px;
  overflow-y: auto;
}

.input-quantity {
  min-width: 75px;
  text-align: center;
}
</style>
